<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div style="background-color: #fff; min-height: 100vh;">
  <!-- Company name, place and login credentials stay pinned to the top while the page scrolls
       (direct child of the page so sticky spans it) -->
  <div class="sticky-credentials">
    <div class="container">
      <div class="row">
        <div class="col-12 p-0">
          <h3 class="font-weight-bold mb-0" style="font-size: 18px;">{{sellerInfo?.BranchName}} <small class="text-muted"
              style="font-size: 16px;">({{sellerInfo.BranchType}})</small>
            <span *ngIf="isMigratedToV2" class="v2-tag" title="Migrated to v2 (Tobeonline) with an active subscription">Migrated to v2</span></h3>
          <div class="text-uppercase text-muted small" style="font-size: 12px;">{{sellerInfo.Place}}</div>
          <div class="small mt-1">Username :<span class="text-dark font-weight-bold">{{sellerInfo.Username}}</span> | psd
            : <span class="text-dark font-weight-bold">{{sellerInfo.Password}}</span></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container pt-2">
    <div class="row">
      <div class="col-12 p-0">
        <div class="input-group mb-1">
          <input class="form-control" [placeholder]="sellerInfo.BranchContact"
            style="opacity: 0.65; box-shadow: none; pointer-events: none;" />

          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="copyContactNumber()">
              <i class="fa fa-copy"></i>
            </button>
            <button class="btn btn-outline-primary" type="button" (click)="callThisNumber()">
              <i class="bi bi-telephone-fill"></i>
            </button>
            <button class="btn btn-outline-success" type="button" (click)="whatsAppThisNumber()" title="WhatsApp">
              <i class="bi bi-whatsapp"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container pb-2">
    <div class="row">
      <div class="col-12 p-0">
        <div>
          <!-- v1: legacy billing data (Servicenear GetBranchStatus) and its actions, collapsed by default -->
          <div class="v1-panel mt-1" [class.open]="isV1PanelOpen">
            <button type="button" class="v1-panel-header" (click)="isV1PanelOpen = !isV1PanelOpen"
              [attr.aria-expanded]="isV1PanelOpen">
              <span class="d-flex align-items-center" style="gap: 6px;">
                <span class="v1-tag ml-0">v1</span>
                <span class="v1-panel-title">Old details</span>
              </span>
              <i class="bi" [ngClass]="isV1PanelOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>

            <div class="v1-panel-body" *ngIf="isV1PanelOpen">
              <div class="small v1-row">Last Paid : <span class="font-weight-bold">{{sellerDetails?.LastPaidDate ?
                  formatUnixToReadable(sellerDetails?.LastPaidDate) : '--'}}</span>
                | Payment Status : <span class="text-danger font-weight-bold">{{sellerDetails?.PaymentStatus}}</span></div>
              <div class="small mt-1 v1-row">Monthly Credit : <span
                  class="font-weight-bold">{{sellerDetails.MonthlyCredit}}</span> | Monthly Usage : <span
                  class="font-weight-bold">{{sellerDetails.MonthlyUsage}}</span></div>
              <div class="small mt-1 v1-row">Payment Banner Status : <span
                  [class.text-success]="sellerDetails.EnablePaymentBanner===true"
                  [class.text-secondary]="sellerDetails.EnablePaymentBanner===false"
                  class="font-weight-bold">{{sellerDetails.EnablePaymentBanner ? "Enabled" : "Not Enabled" }}</span></div>
              <div class="small mt-1 v1-row">Whatsapp : <span [class.text-success]="sellerDetails.WhatsappEnabled"
                  [class.text-secondary]="!sellerDetails.WhatsappEnabled"
                  class="font-weight-bold">{{sellerDetails.WhatsappEnabled ? "Enabled" : "Not Enabled"}}</span> |
                Is Core User
                : <span [class.text-success]="sellerDetails.CoreUser" [class.text-secondary]="!sellerDetails.CoreUser"
                  class="font-weight-bold">{{sellerDetails.CoreUser ? "Yes" : "No"}}</span></div>
              <div class="small mt-1 v1-row">Amount To Pay : <span
                  class="font-weight-bold">{{sellerDetails.PendingBillAmount}}</span></div>

              <div class="v1-actions">
                <div class="d-flex flex-column" style="gap: 0.4rem;">
                  <div class="sub-heading">Payment</div>
                  <div class="d-flex align-items-center" style="gap: 0.5rem;">
                    <button class="btn btn-primary btn-sm px-3" (click)="confirmPayBill()">Pay Bill</button>
                  </div>
                </div>

                <div class="d-flex flex-column" style="gap: 0.4rem;">
                  <div class="sub-heading">Limit</div>
                  <div class="d-flex align-items-center" style="gap: 0.5rem;">
                    <button class="btn btn-danger btn-sm px-3" (click)="confirmUpdateCredit()">Update Credit Limit</button>
                  </div>
                </div>

                <div class="d-flex flex-column" style="gap: 0.4rem;">
                  <div class="sub-heading">Status</div>
                  <div class="d-flex flex-wrap align-items-center" style="gap: 0.5rem;">
                    <button class="btn btn-warning btn-sm px-3" [class.active]="isBannerActive" (click)="confirmToggleBanner()">Pay
                      Banner</button>
                    <button class="btn btn-success btn-sm px-3 d-inline-flex align-items-center" style="gap: 6px;"
                      [class.active]="isWhatsappActive" (click)="confirmToggleWhatsapp()"
                      title="Enables / disables the WhatsApp deeplink for this seller">
                      <i class="bi bi-link-45deg"></i> Whatsapp <span class="btn-note">Deeplink</span>
                    </button>
                  </div>
                </div>

                <div class="d-flex flex-column" style="gap: 0.4rem;">
                  <div class="sub-heading">Migration</div>
                  <div class="d-flex align-items-center" style="gap: 0.5rem;">
                    <button class="btn btn-success btn-sm px-3 d-inline-flex align-items-center" style="gap: 6px;"
                      (click)="confirmMigrateSeller()">
                      <i class="bi" [ngClass]="isTobeonlineBranch ? 'bi-arrow-repeat' : 'bi-box-arrow-up-right'"></i>
                      {{isTobeonlineBranch ? 'Re-run Branch to V2' : 'Branch to V2'}}
                    </button>
                  </div>
                  <div class="migration-note" [class.migrated]="isTobeonlineBranch">
                    <i class="bi bi-info-circle"></i>
                    <span *ngIf="isTobeonlineBranch; else notMigratedNote">
                      Already migrated. Running it again updates the existing V2 details and syncs anything still pending -
                      it does not create a new seller.
                    </span>
                    <ng-template #notMigratedNote>
                      <span>Moves this branch to V2 (Tobeonline). If run again later, it only updates the existing V2 details.</span>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pending bills total, one plain line -->
          <div *ngIf="billTotals.pendingCount > 0" class="bill-summary mt-1">
            <span class="bill-summary-item">
              <span class="bill-summary-label">Pending Bills({{billTotals.pendingCount}})</span>
              <b class="text-danger">{{billTotals.pending | currency : 'INR' : 'symbol' : '1.0-0'}}</b>
            </span>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="page-tab-container">
    <div class="d-flex px-2 w-100" style="gap: 0.5rem;">
      <div (click)="changePage(4)" class="py-2 w-50">
        <div class="page-tabs"
          [ngStyle]="page==4 ? {'background-color':'#673AB7', 'color':'#fff'} : {'background-color':'#B39CDB33','color':'#888888'}">
          Subscription
        </div>
      </div>
      <div (click)="changePage(3)" class="py-2 w-50">
        <div class="page-tabs"
          [ngStyle]="page==3 ? {'background-color':'#673AB7', 'color':'#fff'} : {'background-color':'#B39CDB33','color':'#888888'}">
          Invoice
        </div>
      </div>
      <div (click)="changePage(2)" class="py-2 w-50">
        <div class="page-tabs"
          [ngStyle]="page==2 ? {'background-color':'#673AB7', 'color':'#fff'} : {'background-color':'#B39CDB33','color':'#888888'}">
          Old Invoices
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="page==2" class="p-3">
    <div class="list-section">
      <ng-container *ngIf="loading; else realContent">
        <div class="serviceItem d-flex p-2 my-2" *ngFor="let _ of [].constructor(5)">
          <!-- Left Job Box -->
          <div class="mr-2">
            <div class="jobBox d-flex flex-column align-items-center justify-content-center p-2 skeleton-box"
              style="width:80px; height:90px;">

              <div class="skeleton-text very-short mb-1"></div>
              <div class="d-flex align-items-center">
                <div class="skeleton-text very-short"></div>
              </div>

            </div>
          </div>

          <!-- Right Content -->
          <div class="row no-gutters w-100" style="overflow: hidden;">
            <div class="d-flex align-items-center justify-content-between w-100">

              <!-- Left Text Block -->
              <div class="d-flex flex-column w-75">
                <div class="skeleton-text short mb-1"></div>
                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short"></div>
              </div>

              <!-- Right Amount Block -->
              <div class="d-flex flex-column align-items-end w-25">
                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short mb-1"></div>

                <div class="skeleton-text very-short mb-1"></div>
                <div class="skeleton-text short"></div>
              </div>

            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #realContent>
        <div *ngIf="usageInvoices.length==0" class="no-data-message text-center ">
          No invoices data found.
        </div>
        <ng-container *ngIf="usageInvoices.length!=0">
          <form [formGroup]="whatsAppForm">
            <div formArrayName="entries">
              <div class=" d-flex flex-column workorder-card my-2" *ngFor="let item of usageInvoices; let i = index" >

                <div class="d-flex p-2 py-1">
                  <div class="d-flex flex-column first-section">
                    <div class="d-flex flex-fill">
                      <div class="flex-fill" style="border-radius: 6px; border-width: 0.01rem ; border-style: solid;"
                        [ngStyle]="{ 'border-color' : 'rgba(3, 155, 229)'}">
                        <div class="d-flex flex-column justify-content-center align-items-center h-100">
                          <div class="delivery-date d-flex flex-column align-items-center pt-2 pb-1"
                            [ngStyle]="{'color': 'rgba(3, 155, 229)'}">
                            <div>Total Cost</div>
                            <div class="day">{{item?.TotalCost}}</div>
                          </div>

                          <hr class="w-100 my-0">

                          <div class="delivery-date d-flex flex-column align-items-center pb-2 pt-1" >
                            <div>Total Count</div>
                            <div class="day" style="font-size: 18px;">{{item?.TotalCount}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="pl-2 d-flex flex-column flex-fill" style="min-width: 0;overflow: hidden;">

                    <div class="d-flex align-items-center justify-content-between w-100 h-100">
                      <div class="d-flex flex-column justify-content-between h-100">
                        <div>
                          <div class="d-flex align-items-center" style="color: #6c757d; font-size: 0.85rem;">
                            Bill Period : {{item?.InvoiceDate}}
                          </div>
                          <div class="d-flex flex-column align-items-start " style="font-size: 0.65rem;">
                            <div>
                              Company Cost:
                              <span style="font-weight: 500;">{{item?.CompanyCost}}(Count:
                                {{item?.CompanyCount}})</span>
                            </div>
                            <div>
                              Shop Cost:
                              <span style="font-weight: 500;">{{item?.ShopCost}}(Count: {{item?.ShopCount}})</span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center " style="color: #6c757d; font-size: 0.75rem;">
                          <div (click)="toggleMessage(item, $event)" class="bill-message" [ngClass]="{'two-line-ellipsis': !item._showFullMessage}">
                            <span class="bill-message-text">{{item?.BillMessage}}</span>
                            <a *ngIf="isLongMessage(item?.BillMessage)" class="text-primary bill-toggle-inline"
                               style="background-color: #fff;">
                              {{item._showFullMessage ? 'less' : '...more'}}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center p-2" style="gap: 0.5rem;" [formGroupName]="i">
                  <input formControlName="phoneNo" id="search" class="form-control search-input" type="text"
                    placeholder="Phone" style="height: 40px;" />
                  <button type="button" class="btn btn-success py-1" style="font-size: 0.65rem;"
                    (click)="sendWhatsApp(i, item)">Send to Whatsapp</button>
                </div>

              </div>
            </div>
          </form>
        </ng-container>
      </ng-template>
    </div>
  </div>

  <div *ngIf="page==3" class="px-3 py-2">
    <div class="bg-white" >
      <div *ngIf="!bills || bills.length==0" class="no-data-message text-center ">
        No Data Listed
      </div>

      <div *ngIf="bills && bills.length!=0" class="list-container" style="overflow-y: auto;">
        <div class="serviceItem d-flex p-2 my-2" *ngFor="let item of bills">
          <div class="row no-gutters w-100" style="overflow: hidden;">
            <div class="d-flex align-items-start justify-content-between w-100 ">
              <div class="d-flex flex-column ">
                <div class="customerName mb-1 ellipsis" style="max-width: 200px;">
                  {{item?.PlanName}}
                </div>
                <div class="d-flex align-items-center w-100">
                </div>
  
                <div class="d-flex align-items-center w-100 my-1">
                  <div class=" d-flex align-items-center ellipsis" style="max-width: 130px;">
                    <i class="bi bi-calendar-check mr-1" style="font-size: 13px; color: #757575;"></i> <strong
                      style="color:#757575; font-size: 13px;">{{item?.BillCycle}}</strong>
                  </div>
                  <span class="mx-2" style="font-size: 13px;">|</span>
                  <div class=" d-flex align-items-center ">
                    <i class="bi bi-credit-card mr-1" style="font-size: 13px; color: #757575;"></i> <strong
                      style="color:#757575; font-size: 13px;">{{item?.BillingType}}</strong>
                  </div>
                </div>
  
                <div class="d-flex align-items-center justify-content-between w-100">
                  <div class="paidAmount text-secondary" style="font-size: 13px;">
                    Start: {{item?.StartDateUnix * 1000 | date:'dd MMM yyyy'}} - End:
                    {{item?.EndDateUnix*1000 | date:'dd MMM yyyy'}}
                  </div>
                </div>
  
              </div>
  
              <div class="d-flex flex-column justify-content-start h-100 ">
                <div class="d-flex flex-column align-items-end">
                  <div style="font-size: 12px; color: #757575;">Amount</div>
                  <div style="font-size: 14px; font-weight: 600;">{{item?.TotalAmount | currency :
                    'INR' :
                    'symbol' : '1.0-0'}}</div>
                </div>
  
                <div *ngIf="!item?.isPendingBill; else notPaid" class="d-flex flex-column align-items-end mt-1">
                  <div style="font-size: 12px; color: #757575;" class="">Payment Dt</div>
                  <div style="font-size: 13px; font-weight: 600;">{{item?.PaymentDate | date:'dd MMM yy'}}</div>
                </div>

                <ng-template #notPaid>
                  <small class="text-danger mt-2" style="font-size: 13px; font-weight: 600;">Not Paid</small>
                </ng-template>
  
              </div>
            </div>

            <div *ngIf="item?.isPendingBill" class="d-flex align-items-center w-100 mt-2" style="gap: 0.5rem;">
              <button class="btn btn-outline-secondary btn-sm" (click)="confirmEditBillAmount(item)">Edit Amount</button>
              <button class="btn btn-outline-primary btn-sm" [disabled]="!item?.OrderID" (click)="openBillOrder(item)">Update Payment</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="page==4" class="p-3">
    <div class="d-flex flex-column" style="gap: 1rem;">

      <div class="d-flex align-items-center justify-content-between">
        <div class="sub-heading">Active Plans ({{activeSubscriptions.length}})</div>
        <div class="d-flex align-items-center" style="gap: 0.5rem;">
          <button *ngIf="activeSubscriptions.length>1" class="btn btn-outline-dark btn-sm" (click)="openUsageOrder()">Usage Order</button>
          <button class="btn btn-primary btn-sm" style="background-color:#673AB7; border-color:#673AB7;"
            [disabled]="!isTobeonlineBranch"
            [title]="isTobeonlineBranch ? 'Add another plan' : 'Available only for branches migrated to Tobeonline (v2)'"
            (click)="openAddPlan()">+ Add Plan</button>
        </div>
      </div>

      <!-- Combined limits when more than one plan is running -->
      <div *ngIf="activeSubscriptions.length>1 && combinedFeatures.length>0" class="subscription-card p-3">
        <div class="text-uppercase text-muted" style="font-size: 11px; font-weight: 600; letter-spacing: 0.5px;">Combined Feature Access</div>
        <div class="text-muted mb-2" style="font-size: 12px;">Features of all running plans are combined. Count limits are used plan by plan, starting with the plan that ends first.</div>
        <div class="d-flex align-items-center justify-content-between py-1" style="font-size: 13px;" *ngFor="let feature of combinedFeatures">
          <div class="font-weight-bold">{{feature?.Name}}</div>
          <div *ngIf="feature?.RuleType!=='VALIDITY'">Used <span class="font-weight-bold">{{feature?.Usage}}</span> / <span class="font-weight-bold">{{feature?.LimitValue}}</span></div>
          <div *ngIf="feature?.RuleType==='VALIDITY'" class="text-muted">Unlimited</div>
        </div>
      </div>

      <ng-container *ngIf="activeSubscriptions.length>0; else noSubscriptionPlan">
        <!-- One card per running plan; every action applies to that card's plan -->
        <div class="subscription-card p-3 d-flex flex-column" style="gap: 0.75rem;" *ngFor="let sub of activeSubscriptions; let i = index">
          <div class="d-flex align-items-start justify-content-between">
            <div>
              <div class="text-uppercase text-muted" style="font-size: 11px; font-weight: 600; letter-spacing: 0.5px;">
                {{sub.SubscriptionPlanHeader?.ParentPlanID ? 'Add-on' : 'Subscription'}}
                <span *ngIf="activeSubscriptions.length>1" class="ml-1" style="color:#673AB7;">• Used {{i+1}}{{i==0 ? 'st' : i==1 ? 'nd' : i==2 ? 'rd' : 'th'}}</span>
              </div>
              <div class="font-weight-bold" style="font-size: 16px; color: #2c3e50;">{{sub.SubscriptionPlanHeader?.PlanName}}</div>
              <div class="text-muted" style="font-size: 12px; font-weight: 600;">{{sub.SubscriptionPlanHeader?.BillingType}} | {{sub.SubscriptionPlanHeader?.BillCycle}}</div>
            </div>
            <div class="d-flex flex-column align-items-end" style="gap: 6px;">
              <span class="status-badge" [class.status-active]="!sub.SubscriptionPlanHeader?.IsExpired" [class.status-expired]="sub.SubscriptionPlanHeader?.IsExpired">
                {{sub.SubscriptionPlanHeader?.IsExpired ? 'Expired' : 'Active'}}
              </span>
              <!-- Count usage of this plan (CREATE_JOB, else first COUNT feature): used / total -->
              <div *ngIf="getUsageSummary(sub) as usage" class="plan-usage-summary">
                <div class="plan-usage-value">
                  <span class="used" [class.text-danger]="usage.isFull">{{usage.used}}</span>
                  <span class="total">/ {{usage.limit}}</span>
                </div>
                <div class="plan-usage-label">Used / Total</div>
              </div>
            </div>
          </div>

          <hr class="my-0">

          <div>
            <div class="d-flex align-items-center justify-content-between" style="font-size: 13px;">
              <div>Start: <span class="font-weight-bold">{{sub.SubscriptionPlanHeader?.StartDateUnix ? (sub.SubscriptionPlanHeader?.StartDateUnix*1000 | date:'dd MMM yyyy') : '--'}}</span></div>
              <div>End: <span class="font-weight-bold">{{sub.SubscriptionPlanHeader?.EndDateUnix ? (sub.SubscriptionPlanHeader?.EndDateUnix*1000 | date:'dd MMM yyyy') : '--'}}</span></div>
            </div>

            <div class="d-flex align-items-center mt-1" style="font-size: 13px;">
              <div>Grace Period Ends: <span class="font-weight-bold">{{sub.SubscriptionPlanHeader?.PaymentGracePeriod ? (sub.SubscriptionPlanHeader?.PaymentGracePeriod*1000 | date:'dd MMM yyyy, hh:mm a') : '--'}}</span></div>
              <span *ngIf="isGracePeriodExpired(sub.SubscriptionPlanHeader)" class="status-badge status-expired ml-2">Grace Expired</span>
            </div>
          </div>

          <div class="d-flex flex-wrap align-items-center" style="gap: 0.5rem;">
            <button class="btn btn-outline-primary btn-sm" (click)="openUpdateValidity(sub)">Update Validity</button>
            <button class="btn btn-outline-warning btn-sm" (click)="openUpdateGracePeriod(sub)">Update Grace Period</button>
          </div>

          <div class="d-flex flex-column" style="gap: 0.5rem;">
            <div class="sub-heading">Status</div>
            <div class="d-flex flex-wrap align-items-center" style="gap: 0.5rem;">
              <button class="btn btn-warning btn-sm px-3" (click)="confirmToggleSubscriptionExpiredFor(sub)">{{sub.SubscriptionPlanHeader?.IsExpired ? 'Reactivate' : 'Mark Expired'}}</button>
              <button class="btn btn-danger btn-sm px-3" (click)="confirmCancelSubscriptionPlanFor(sub)">Cancel Plan</button>
            </div>
          </div>

          <!-- Feature limits / usage of this plan -->
          <div class="d-flex flex-column" style="gap: 0.5rem;">
            <div class="sub-heading">Feature Limits &amp; Usage</div>

            <div *ngIf="!sub.SubscriptionPlanDetails?.length" class="no-data-message text-center">
              No feature limits configured.
            </div>

            <div class="feature-row d-flex align-items-center justify-content-between p-2" *ngFor="let feature of sub.SubscriptionPlanDetails">
              <div>
                <div class="font-weight-bold" style="font-size: 14px;">{{feature?.Name}}</div>
                <div class="text-muted" style="font-size: 12px;">{{feature?.RuleType}}</div>
                <div style="font-size: 13px;">Used <span class="font-weight-bold">{{feature?.Usage}}</span> Out of <span class="font-weight-bold">{{feature?.LimitValue}}</span></div>
              </div>
              <button class="btn btn-outline-secondary btn-sm" (click)="openFeatureEdit(feature, sub)">Edit</button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noSubscriptionPlan>
        <div class="no-data-message text-center">
          No subscription plan found for this customer.
        </div>
      </ng-template>

    </div>
  </div>


  <!-- Subscription Edit Modal -->
  <div *ngIf="subEditModalVisible" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{subEditTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeSubEditModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div [formGroup]="subscriptionForm" class="modal-body">
          <div *ngIf="subEditMode=='validity'" class="d-flex flex-column" style="gap: 0.75rem;">
            <div>
              <label class="small text-muted mb-1">Start Date</label>
              <input formControlName="startDate" class="form-control" type="date">
            </div>
            <div>
              <label class="small text-muted mb-1">End Date</label>
              <input formControlName="endDate" class="form-control" type="date">
            </div>
          </div>

          <div *ngIf="subEditMode=='grace'" class="d-flex flex-column" style="gap: 0.75rem;">
            <div>
              <label class="small text-muted mb-1">Grace period after {{graceBaseLabel}}</label>
              <div class="grace-chips">
                <button type="button" class="grace-chip" *ngFor="let days of gracePresetDays"
                  [class.selected]="!graceCustomMode && graceDaysFromEnd===days" (click)="selectGracePreset(days)">
                  {{days}} days
                </button>
                <button type="button" class="grace-chip" [class.selected]="graceCustomMode" (click)="selectGraceCustom()">
                  <i class="bi bi-calendar3 mr-1"></i>Custom
                </button>
              </div>
            </div>

            <div *ngIf="graceCustomMode">
              <label class="small text-muted mb-1">Grace Period Ends On</label>
              <input formControlName="gracePeriodDate" class="form-control" type="date"
                [min]="graceBaseDate.format('YYYY-MM-DD')">
            </div>

            <!-- Result: chosen date and how many days it is after the plan end date -->
            <div *ngIf="graceDaysFromEnd !== null" class="grace-summary" [class.invalid]="graceDaysFromEnd < 0">
              <div class="d-flex align-items-center justify-content-between">
                <span>Grace ends on</span>
                <span class="font-weight-bold">{{subscriptionForm.value.gracePeriodDate | date:'dd MMM yyyy'}}</span>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-1">
                <span>{{graceBaseLabel | titlecase}}</span>
                <span>{{graceBaseDate.toDate() | date:'dd MMM yyyy'}}</span>
              </div>
              <div class="grace-days mt-2">
                <ng-container *ngIf="graceDaysFromEnd >= 0; else graceBeforeEnd">
                  <span class="grace-days-value">{{graceDaysFromEnd}}</span> {{graceDaysFromEnd === 1 ? 'day' : 'days'}} after {{graceBaseLabel}}
                </ng-container>
                <ng-template #graceBeforeEnd>
                  {{-graceDaysFromEnd}} {{graceDaysFromEnd === -1 ? 'day' : 'days'}} before {{graceBaseLabel}} - choose a later date
                </ng-template>
              </div>
            </div>
          </div>

          <div *ngIf="subEditMode=='feature'" class="d-flex flex-column" style="gap: 0.75rem;">
            <div>
              <label class="small text-muted mb-1">Limit Value</label>
              <input formControlName="limitValue" class="form-control" type="number">
            </div>
            <div>
              <label class="small text-muted mb-1">Usage</label>
              <input formControlName="usage" class="form-control" type="number">
            </div>
          </div>

          <div *ngIf="subEditMode=='priority'" class="d-flex flex-column" style="gap: 0.75rem;">
            <div class="usage-order-hint">
              Drag (or use the arrows) to set which plan's limit is used first. Cancelled, expired, ended or full plans are skipped.
            </div>

            <div cdkDropList class="d-flex flex-column" style="gap: 0.5rem;" (cdkDropListDropped)="dropUsageOrder($event)">
              <div class="usage-order-row d-flex align-items-center" *ngFor="let sub of usageOrderList; let i = index" cdkDrag cdkDragLockAxis="y">
                <span class="usage-order-handle" cdkDragHandle aria-label="Drag to reorder"><i class="bi bi-grip-vertical"></i></span>
                <span class="usage-order-index">{{i+1}}</span>

                <div class="flex-grow-1" style="min-width: 0;">
                  <div class="d-flex align-items-center" style="gap: 0.375rem;">
                    <span class="usage-order-name text-truncate">{{sub.SubscriptionPlanHeader?.PlanName}}</span>
                    <span *ngIf="getUsageSummary(sub)?.isFull" class="status-badge status-expired">Full</span>
                  </div>
                  <div class="usage-order-meta">
                    {{sub.SubscriptionPlanHeader?.BillingType}} | {{sub.SubscriptionPlanHeader?.BillCycle}}
                    | ends {{sub.SubscriptionPlanHeader?.EndDateUnix ? (sub.SubscriptionPlanHeader?.EndDateUnix*1000 | date:'dd MMM yyyy') : '--'}}
                    <ng-container *ngIf="getUsageSummary(sub) as usage"> | used {{usage.used}}/{{usage.limit}}</ng-container>
                  </div>
                  <div *ngIf="getUsageSummary(sub) as usage" class="usage-order-bar"><span [style.width.%]="usage.percent"></span></div>
                </div>

                <div class="d-flex flex-column usage-order-arrows">
                  <button type="button" class="btn btn-sm" [disabled]="i==0" (click)="moveUsageOrder(i, -1)" aria-label="Move up"><i class="bi bi-chevron-up"></i></button>
                  <button type="button" class="btn btn-sm" [disabled]="i==usageOrderList.length-1" (click)="moveUsageOrder(i, 1)" aria-label="Move down"><i class="bi bi-chevron-down"></i></button>
                </div>

                <button type="button" class="btn btn-sm usage-order-cancel" (click)="cancelPlanFromUsageOrder(sub)">Cancel</button>
              </div>
            </div>
          </div>

          <div *ngIf="subEditMode=='addPlan'" class="small text-muted mb-2">
            Select one plan to add next to the current plan(s) - nothing is switched or expired, and feature access of all
            running plans is combined. To add another plan, open Add Plan again after this one is added.
          </div>

          <div *ngIf="subEditMode=='addPlan'" class="d-flex flex-column" style="gap: 0.5rem; max-height: 50vh; overflow-y: auto;">
            <div *ngIf="plansLoading" class="d-flex justify-content-center py-3">
              <div class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </div>

            <div *ngIf="!plansLoading && addablePlans.length==0" class="no-data-message text-center">
              No subscription plans available.
            </div>

            <div class="plan-pick-row d-flex align-items-center justify-content-between p-2"
              *ngFor="let plan of addablePlans"
              [class.plan-pick-selected]="selectedPlanId===plan.ID"
              (click)="selectPlan(plan)">
              <div class="flex-grow-1" style="min-width: 0;">
                <div class="font-weight-bold" style="font-size: 14px;">
                  {{plan?.PlanName}}
                  <span *ngIf="isPlanRunning(plan.ID)" class="status-badge status-active ml-1">Running</span>
                </div>
                <div class="text-muted" style="font-size: 12px;">{{plan?.Price ? (plan?.Price | currency:'INR':'symbol':'1.0-0') : 'Free'}} / {{plan?.BillCycle}} | {{plan?.BillingType}}</div>
                <div *ngIf="getPlanDescription(plan) as description" class="plan-pick-description">{{description}}</div>
                <div *ngIf="plan?.Features?.length" class="d-flex flex-wrap mt-1" style="gap: 4px;">
                  <span class="plan-limit-chip" *ngFor="let feature of plan.Features">{{getPlanFeatureLimitLabel(feature)}}</span>
                </div>
              </div>
              <div class="d-flex align-items-center flex-shrink-0 ml-2" style="gap: 0.5rem;">
                <button type="button" class="btn btn-sm plan-details-btn" (click)="openPlanDetails(plan, $event)">View details</button>
                <input type="radio" name="addPlanRadio" [checked]="selectedPlanId===plan.ID" style="width: 18px; height: 18px;">
              </div>
            </div>
          </div>

          <div *ngIf="subEditMode=='addPlan'" class="d-flex flex-column mt-1" style="gap: 0.5rem;">
            <div class="form-check">
              <input formControlName="selectNewDate" class="form-check-input" type="checkbox" id="selectNewDateCheck">
              <label class="form-check-label small" for="selectNewDateCheck">
                Set custom start and end date (default: starts today, ends per bill cycle)
              </label>
            </div>

            <div *ngIf="subscriptionForm.value.selectNewDate" class="d-flex flex-column" style="gap: 0.75rem;">
              <div>
                <label class="small text-muted mb-1">New Plan Start Date</label>
                <input formControlName="newPlanStartDate" class="form-control" type="date">
              </div>
              <div>
                <label class="small text-muted mb-1">New Plan End Date</label>
                <input formControlName="newPlanEndDate" class="form-control" type="date">
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="d-flex align-items-center justify-content-between w-100" style="gap: 0.5rem;">
            <button (click)="closeSubEditModal()" class="btn btn-primary"
              style="background-color:#fff; color:#808080; border-color:#808080;flex: 1 1 0;">
              Cancel
            </button>

            <button (click)="saveSubscriptionEdit()" [disabled]="isAddPlanSaveDisabled || isPrioritySaveDisabled || isGraceSaveDisabled" class="btn btn-primary"
              style="background-color:#673AB7; color:#fff; border-color:#673AB7;flex: 1 1 auto;">
              <ng-container *ngIf="subEditMode=='addPlan'; else defaultSaveLabel">{{addPlanSaving ? 'Adding...' : 'Add Plan'}}</ng-container>
              <ng-template #defaultSaveLabel>Save</ng-template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Plan Details Modal (opened from "View details" in the Add Plan list; sits above it) -->
  <div *ngIf="planDetails" class="modal fade show px-1 plan-details-modal" style="display: block; background: #00000040;">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h5 class="modal-title mb-0">{{planDetails?.PlanName}}</h5>
            <div class="text-muted" style="font-size: 12px;">{{planDetails?.ParentPlanID ? 'Add-on plan' : 'Main plan'}}</div>
          </div>
          <button type="button" class="close" aria-label="Close" (click)="closePlanDetails()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body d-flex flex-column" style="gap: 1rem;">
          <div *ngIf="getPlanDescription(planDetails) as description" class="plan-details-description">{{description}}</div>

          <div>
            <div class="sub-heading mb-1">Pricing</div>
            <div class="plan-details-row"><span>Price</span><span class="font-weight-bold">{{planDetails?.Price ? (planDetails?.Price | currency:'INR':'symbol':'1.0-2') : 'Free'}}</span></div>
            <div *ngIf="planDetails?.Discount" class="plan-details-row"><span>Discount</span><span class="font-weight-bold">{{planDetails?.Discount | currency:'INR':'symbol':'1.0-2'}}</span></div>
            <div class="plan-details-row"><span>Billing type</span><span class="font-weight-bold">{{planDetails?.BillingType || '--'}}</span></div>
            <div class="plan-details-row"><span>Bill cycle</span><span class="font-weight-bold">{{planDetails?.BillCycle || '--'}}</span></div>
            <div class="plan-details-row"><span>Payment grace period</span><span class="font-weight-bold">{{planDetails?.PaymentGracePeriod || 0}} days</span></div>
          </div>

          <div>
            <div class="sub-heading mb-1">Limits</div>
            <div *ngIf="!planDetails?.Features?.length" class="text-muted" style="font-size: 13px;">No limits configured.</div>
            <div class="plan-details-row" *ngFor="let feature of planDetails?.Features">
              <span>{{feature?.FeatureName || feature?.FeatureUniq}} <small class="text-muted">({{feature?.RuleType}})</small></span>
              <span class="font-weight-bold">{{(feature?.RuleType || '').toUpperCase() === 'VALIDITY' ? 'Unlimited' : feature?.LimitValue}}</span>
            </div>
          </div>

          <div *ngIf="getPlanModules(planDetails) as modules">
            <ng-container *ngIf="modules.length">
              <div class="sub-heading mb-1">Included modules</div>
              <div class="d-flex flex-wrap" style="gap: 6px;">
                <span class="plan-module-chip" *ngFor="let module of modules">{{module}}</span>
              </div>
            </ng-container>
          </div>

          <div *ngIf="getPlanAddOns(planDetails) as addOns">
            <ng-container *ngIf="addOns.length">
              <div class="sub-heading mb-1">Add-ons for this plan</div>
              <div class="plan-details-row" *ngFor="let addOn of addOns">
                <span>{{addOn?.PlanName}}</span>
                <span class="font-weight-bold">{{addOn?.Price ? (addOn?.Price | currency:'INR':'symbol':'1.0-0') : 'Free'}} / {{addOn?.BillCycle}}</span>
              </div>
            </ng-container>
          </div>

          <div>
            <div class="sub-heading mb-1">Status</div>
            <div class="plan-details-row"><span>Active</span><span class="font-weight-bold">{{planDetails?.IsActive ? 'Yes' : 'No'}}</span></div>
            <div class="plan-details-row"><span>Visible to customers</span><span class="font-weight-bold">{{planDetails?.IsVisible ? 'Yes' : 'No'}}</span></div>
            <div *ngIf="planDetails?.CreatedOnUnix" class="plan-details-row"><span>Created</span><span class="font-weight-bold">{{planDetails?.CreatedOnUnix*1000 | date:'dd MMM yyyy'}}</span></div>
            <div *ngIf="planDetails?.UpdateOnUnix" class="plan-details-row"><span>Last updated</span><span class="font-weight-bold">{{planDetails?.UpdateOnUnix*1000 | date:'dd MMM yyyy'}}</span></div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="d-flex align-items-center justify-content-between w-100" style="gap: 0.5rem;">
            <button (click)="closePlanDetails()" class="btn btn-primary"
              style="background-color:#fff; color:#808080; border-color:#808080;flex: 1 1 0;">
              Close
            </button>
            <button (click)="selectPlanFromDetails()" class="btn btn-primary"
              style="background-color:#673AB7; color:#fff; border-color:#673AB7;flex: 1 1 auto;">
              Select this plan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirm Modal -->
  <div *ngIf="confirmVisible" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{confirmTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="confirmVisible = false;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <p>{{confirmMessage}}</p>
        </div>

        <div *ngIf="confirmAmount" [formGroup]="amountForm" class="px-3 pb-3">
          <input formControlName="amount" class="form-control search-input" type="text"
                    placeholder="amount" style="height: 40px;" />
        </div>

        <div class="modal-footer">
          <div class="d-flex align-items-center justify-content-between w-100" style="gap: 0.5rem;">
            <button *ngIf="!isPaidJob" (click)="confirmCancel()" class=" btn btn-primary "
              style="background-color:#fff; color:#808080; border-color:#808080;flex: 1 1 0;">
              {{confirmCancelLabel}}
            </button>

            <button *ngIf="!isPaidJob" (click)="confirmCallback()" class=" btn btn-primary "
              style="background-color:#673AB7; color:#fff; border-color:#673AB7;flex: 1 1 auto; ">
              {{confirmConfirmLabel}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>